import { useMemo } from "react"
import { StepOption } from "../../../../types/wizard"
import { getColorStyle } from "../../../../actions/wizard"

export default function SelectedColor({ color, isClosestMatch }: { color: StepOption, isClosestMatch?: boolean }) {
  const colorStyleDiv = useMemo(() => getColorStyle(color), [color])

  return (
    <div className="grid grid-cols-[4.5rem_1fr] gap-2 mt-2">
      <div className="w-full h-20 border border-slate-500/7" style={{ ...colorStyleDiv }}></div>
      <div className="text-left text-xs">
        <h4 className="font-bold">{isClosestMatch ? "Closest Match" : "Selected color"}</h4>
        <p className="text-[16px] font-bold">{color?.name}</p>
        {color?.colorCodePMS ? <p>PMS: {color.colorCodePMS}</p> : null}
        {color?.htmlColor ? <p>Hex: {color.htmlColor}</p> : null}
        {color?.colorCodeMadeira ? <p>Madeira: {color.colorCodeMadeira}</p> : null}
        {color?.colorCodeRobisonAnton ? <p>Robinson-Anton: {color.colorCodeRobisonAnton}</p> : null}
      </div>
    </div>
  )
}